export const ErrorMessages = {
    EmailRequired: "Please Enter Email Address",
    InvalidEmail: "Please Enter a valid Email Address",
    PasswordRequired: "Please Enter Password",
    WrongUser: "Invalid Email/Password",
    NameRequired: "Please Enter Name",
    OverviewRequired: "Please Enter Overview",
    firstnameRequired: "Please Fnter First Name.",
    LastNameRequired: "Please Enter Last Name",
    UserNameRequired: "Please Enter UserName",
    designationRequired: "Please Enter Designation.",
    locationRequired: "Please Enter location Name.",
    Business_OverviewRequired: "Overview Required",
    EmployeesRequired: "Employess Required",
    SupplierNameRequired: "name required",
    Number_of_Employees: "employees required",
    TitleRequired: "Title Required",
    DescriptionRequired: "Description Required",
    BuyerRequired: "Please Select Buyer",
    OfferingsRequired: "please Enter Offerings.",
    rattingRequired: "please Enter Ratings.",
    yearRequired: "Please Enter company Registered Year.",
    ContactDetailsRequired: "Please Enter Contect Details.",
    noofEmployeesRequired: "Please Enter Numer of employees.",
    StaffdesignationRequired: "Please Select Designation"
    
}

export const DefaultMessages = {
    SuccessLogin: "Login Successfull!..",
    RecordInserted: "Record Inserted Successfully..",
    RecordUpdated: "Record Updated Successfully..",
    RecordDeleted: "Record Deleted Successfully.."
}